exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rebate-container {\n  border: 1px solid #efd2d2;\n  border-top: transparent;\n  background: #fefefe;\n  padding: 10px 15px;\n  color: #555;\n  font-size: 1.2em; }\n\n.rebate-container:first-child {\n  border-top: 1px solid #efd2d2;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px; }\n\n.rebate-container:last-child {\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px; }\n\n.rebate-container p {\n  margin: 0; }\n\n.rebate-container__field-name {\n  display: inline-block;\n  font-weight: bold; }\n\n.rebate-container__field-name::after {\n  content: ':';\n  display: inline-block; }\n\n.no-rebates {\n  text-align: center;\n  font-size: 3em;\n  text-shadow: 1px 1px 1px #fff;\n  margin: 1.5em 0; }\n\n.no-rebates a,\n.no-rebates a:hover,\n.no-rebates a:focus {\n  text-decoration: none;\n  color: #8ac440; }\n\n@media screen and (max-width: 767px) {\n  .rebate-container__field-name {\n    width: 100%; }\n  .rebate-container__field-name::after {\n    display: none; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/rebates/rebates/rebates.component.scss
// module id = ../../../../../angular/app/components/rebates/rebates/rebates.component.scss
// module chunks = 1